import React, { useContext, useState } from "react";
import { Card, Layout } from "@shopify/polaris";

// import helper
import { storageHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";

// import components
import { SingleColumnLayout } from "layout/private/components";
import { Banner, SkeletonList } from "lib/components";
import { QuickAction } from "app/reports";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

// import subFeature
import PaymentList from "app/paymentsLake/modules/generic/list/list";

const ProviderPaymentList = () => {
  const { isLoading } = useContext(PrivateContext);

  const [banner, setBanner] = useState({
    isOpen: false,
    title: "",
    status: "",
    message: "",
  });

  // const linkData = [
  //   {
  //     action: () => setModal(!isOpenModal),
  //     caption: cms("label.caption"),
  //     id: "exportPayment",
  //     icon: ExportMinor,
  //     label: cms("label.export"),
  //     shop: true,
  //   },
  //   {
  //     action: () => history.push("/payments/credit-note"),
  //     caption: cms("label.access"),
  //     icon: BalanceMajor,
  //     id: "creditNoteBalance",
  //     label: cms("label.balance"),
  //   },
  // ];

  const toggleBanner = () => {
    setBanner({ isOpen: false });
  };
  const getComponent = () => {
    if (isLoading) {
      return <SkeletonList />;
    }
    return (
      <>
        <Layout>
          {banner.isOpen && (
            <Layout.Section>
              <Banner status={banner.status} isOpen={banner.isOpen} title={banner.title} onDismiss={toggleBanner} />
            </Layout.Section>
          )}
          <Layout.Section>
            {/* <QuickAction link={linkData} /> */}
            <QuickAction />
            <Card>
              <PaymentList setBanner={setBanner} />
            </Card>
          </Layout.Section>
        </Layout>
      </>
    );
  };

  const currentUserRole = storageHelper.get("userRole");
  //  <TwoColumnLayout primary={getComponent(currentUserRole)} secondary={getSecondaryComponent()} />
  return <SingleColumnLayout primary={getComponent(currentUserRole)} />;
};

export default withFeature(withErrorBoundary(ProviderPaymentList), { feature: constant.PAYMENTS });
